module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--11--create-1ffba886.jpg";